module.exports = __webpack_public_path__ + "static/media/modalClose.e69ad07c.svg";